import React, { Component } from "react";
import { View, Text, StyleSheet, Dimensions } from "react-native";

import * as x from "styles/css";

class KeyboardView extends Component {
	constructor(props) {
		super(props);

		this.state = {
			width: Dimensions.get("window").width,
			height: Dimensions.get("window").height,
		}

		this.handleLayout = this.handleLayout.bind(this);
	}

	componentDidMount() {
		this.setState({
			width: Dimensions.get("window").width,
			height: Dimensions.get("window").height,
		});
	}

	handleLayout(evt) {
		this.setState({
			width: Dimensions.get("window").width,
			height: Dimensions.get("window").height,
		});
	}

	render() {
		return (
			<View
				onLayout={this.handleLayout}
				style={[
					this.state.width <= 600 ? styles.mobile : styles.view,
					this.state.width <= 600 ? {} : x.mx.auto,
					this.props.style,
				]}
			>
				{this.props.children}
			</View>
		);
	}
}

const styles = StyleSheet.create({
	view: {
		marginBottom: 20,
		marginTop: 20,
		width: 500,
		height: 600,
		padding: 30,
		backgroundColor: "white",
	},
	mobile: {
		flex: 1,
		backgroundColor: "white",
		padding: 30,
	},
});

export default KeyboardView;



// WEBPACK FOOTER //
// ./src/components/KeyboardView/index.web.js